<template>
	<form-field-wrap
			:field-props="fieldProps"
			:is-error="isError"
			:field-value="fieldValue"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
			:with-label="withLabel"
			:tabindex="0"
			@change-value="changeValue(!inputValue)"
			:class="'form__checkbox'"
	>
		<label class="form-checkbox">
		<input class="form-field__input"
		       @click="onClickValue"
		       :class="[inputClass, 'form-field__input_'+fieldProps.CODE]"
		       :name="fieldProps.CODE"
		       type="checkbox"
		       :checked="fieldValue"
		       @change="changeValue"
		       v-validate="rules"
		       :data-vv-as="fieldProps.TITLE"
		       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE">
		<span></span>
		<div class="form-checkbox__text" v-html="fieldProps.TITLE"></div>
		</label>
	</form-field-wrap>
</template>

<script>
	export default {
		name: "FormFieldCheckbox",
		props: {
			withLabel: {
				type: Boolean,
				default: false
			}
		},
		model: {
			event: 'change'
		},
		methods: {
			changeValue($event) {
				this.inputValue = $event.target.checked;
				this.$emit('change', $event.target.checked);
			},
			onClickValue($event) {
				this.$emit('click', $event);
			}
		}
	}
</script>